import React, { useContext, useEffect, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import './calendar.css';
import { isMobile } from "react-device-detect";
import { AppContext, UserContext } from "../../../AppContextProvider";
import { useTranslation } from "react-i18next";
import frLocale from '@fullcalendar/core/locales/fr';
import arLocale from '@fullcalendar/core/locales/ar';


export default function EventCalendar({eventsData}) {

  const [UserState,setUserState] = useContext(UserContext);
  const [AppState,SetAppState] = useContext(AppContext);
  const {t} = useTranslation();

  const status_colors = {
    'default':'goldenrod'
  }

  const [events, setEvents] = useState([]);

  const parse_date=(datestr)=>{
    if (!datestr) return null;
    if (datestr.includes("/")) {
        const [d, m, y] = datestr.split("/").map(Number);
        return new Date(y, m - 1, d).toISOString().split("T")[0];
    }
    //const [d,m,y] = datestr.split("/").map(Number);
    return datestr;//new Date(y,m-1,d).toISOString();
  }

  useEffect(()=>{
    if (!eventsData || !Array.isArray(eventsData)) return;

    let _events = [];
    eventsData.forEach(e=>{
      let _status = 'default';
      if(!!e.order)
        _status = status_colors[_status];
      let _phone = "";
      if(e.client.phone && e.client.phone!=='')
        _phone = '('+e.client.phone+')';
      _events.push({title:UserState.is_staff?e.client.label_name+_phone:t('produit.loue'),
        start:parse_date(e.date),
        backgroundColor:'orangered',
        textColor:'black',
        display:'block',
        className:'calendar-event'
      });})
    setEvents([..._events]);
  },[eventsData])

  const handleDateClick = (info) => {

  };

  let right_bts = "today,dayGridWeek,dayGridMonth"
  if(isMobile)
    right_bts = "dayGridWeek,dayGridMonth"


  return (
    <div className="p-4 max-w-4xl mx-auto">
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="dayGridWeek"
        selectable={true}
        editable={true}
        events={events}
        locale={AppState.settings.lang==='ar'?arLocale:frLocale}
        dateClick={handleDateClick}
        event
        eventTimeFormat={false}
        displayEventTime={false}
        buttonText={{
        today: t('produit.aujourd_hui'),//"Aujourd'hui", 
        month: t('produit.mois'),//'Mois',
        week: t('produit.semaine'),//'Semaine',
        day: t('produit.jour'),//'Jour',
        }}
        headerToolbar={{
          left: "prev,next",
          center: "title",
          right: right_bts//"dayGridMonth,timeGridWeek,timeGridDay",
        }}
      />
    </div>
  );
}